import { EmailConfigurationActionTypes, EmailConfigurationActions } from './email-configuration.actions';
import { IEmailConfiguration } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    emailConfig: IEmailConfiguration | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    emailConfig: null
};

export function reducer(state = initialState, action: EmailConfigurationActions): State {
    switch (action.type) {

        case EmailConfigurationActionTypes.LoadEmailConfigurationState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case EmailConfigurationActionTypes.LoadEmailConfigurationStateSuccess: {
            return {
                ...state,
                error: null,
                pending: false,
                emailConfig: action.payload
            };
        }

        case EmailConfigurationActionTypes.LoadEmailConfigurationStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case EmailConfigurationActionTypes.SubmitEmailTemplate: {
            return {
                ...state,
                pending: true
            }
        }

        case EmailConfigurationActionTypes.EmailConfigurationScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 
        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getEmailConfigData = (state: State) => state.emailConfig;